import {useContext, useState} from 'react'

import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import AtomButton, {atomButtonDesigns, atomButtonShapes, atomButtonSizes} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import MoleculeAvatar, {MOLECULE_AVATAR_SIZES} from '@s-ui/react-molecule-avatar'
import {useLocation} from '@s-ui/react-router'

import {ROUTES} from '../../../../../config/index.js'
import UserCloseSessionModal from './UserCloseSessionModal.js'

const UserWelcomeSection = ({userData}) => {
  const {i18n} = useContext(Context)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const {pathname} = useLocation()

  const userDataExists = Object.keys(userData).length > 0
  const isPurchaseFlow = pathname === ROUTES.USER.PROFILE_COMPLETE.PURCHASE

  const handleModal = state => setIsModalOpen(state)

  return (
    <div className="mt-UserProfileComplete-userFormWelcomeContainer">
      {userDataExists && (
        <>
          <div className="mt-UserProfileComplete-userFormWelcomeUserData">
            <MoleculeAvatar size={MOLECULE_AVATAR_SIZES.XLARGE} src={userData.avatar} />
            <div className="mt-UserProfileComplete-userFormWelcomeText">
              <span className="mt-UserProfileComplete-userFormWelcomeItem--bold">
                {i18n.t('RESERVATION_C2B.USER_FORM.WELCOME_TEXT', {
                  userName: userData.name
                })}
              </span>
              <span className="mt-UserProfileComplete-userFormWelcomeItem">
                {htmlStringToReactElement(
                  i18n.t('RESERVATION_C2B.USER_FORM.USER_INFO_TEXT', {
                    strongStart: '<strong>',
                    userEmail: userData.email,
                    strongEnd: '</strong>'
                  })
                )}
              </span>
            </div>
          </div>
          <div className="mt-UserProfileComplete-userFormWelcomeCta">
            <AtomButton
              design={atomButtonDesigns.OUTLINE}
              fullWidth
              onClick={() => handleModal(true)}
              shape={atomButtonShapes.CIRCULAR}
              size={atomButtonSizes.SMALL}
            >
              {isPurchaseFlow ? i18n.t('COMMON.LOG_OUT_SWITCH_ACCOUNT') : i18n.t('COMMON.SWITCH_ACCOUNT')}
            </AtomButton>
          </div>
          {isModalOpen && <UserCloseSessionModal handleModal={handleModal} />}
        </>
      )}
    </div>
  )
}

UserWelcomeSection.displayName = 'UserWelcomeSection'
UserWelcomeSection.propTypes = {
  userData: PropTypes.object
}

export default UserWelcomeSection
